import { z } from 'zod';

import { SignUpMethod } from 'src/api';

import { EmployeeSettingsFormFields, EmployeeSettingsFormValues } from '../types';

export const employeeSettingsFormValidationSchema = z.object({
  [EmployeeSettingsFormFields.signUpMethod]: z.enum(SignUpMethod),
  [EmployeeSettingsFormFields.pinHint]: z
    .string()
    .max(200, 'PIN Hint must be at most 200 characters')
    .nullish(),
  [EmployeeSettingsFormFields.isLive]: z.boolean(),
}) satisfies z.ZodType<EmployeeSettingsFormValues>;
